import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const LazyAbandonedBrandCartNudge = loadable(
  () =>
    /* webpackChunkName: "abandoned-brand-cart-nudge" */ import(
      "./AbandonedBrandCartNudge"
    ).catch(handleComponentLoadError),
  { resolveComponent: (m) => m.AbandonedBrandCartNudge }
);
